import { z } from 'zod'
import typeguard from '../typeguard'
import { alsoPurchasedSchema, crossSellSectionSchema, crossSellSectionsSchema, isProduct, tProduct } from './product'

export const productRecommendationsSchema = z.object({
  alsoPurchased: z.array(alsoPurchasedSchema.element.extend({
    productDetails: z.union([z.custom<tProduct>(value => isProduct(value, false)), z.object({}).strict()]),
  })),
  crossSellSections: crossSellSectionsSchema,
  dynamicSerie: z.object({
    selectionKey: z.string(),
    section: crossSellSectionSchema.nullable(),
  }).optional(),
})

export type tProductRecommendations = z.infer<typeof productRecommendationsSchema>
export const isProductRecommendations = typeguard<tProductRecommendations>(productRecommendationsSchema)
